/* eslint-disable react/display-name */
import { Fragment, memo } from 'react';

import { Button } from '@dec/shared';
import { ButtonAction } from '@dec/shared';
import { HookFormResolver } from '@dec/shared';
import { BtnGroup } from '@dec/shared';
import { BtnToolbar } from '@dec/shared';
import TaxReturnForm from 'app/modules/FormDefinition/components/Form';
import { useGetTaxReturnById } from 'app/modules/Reports/TaxReturnList/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import { buttons } from '../translation';

interface Props {}

export const TaxreturnReview = memo((props: Props) => {
  const { id } = useParams<Record<string, string>>();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const onCancel = () => {
    navigate(`/statements/taxreturn-evaluation`);
  };
  const { loading, taxreturn } = useGetTaxReturnById(id ?? '');

  if (loading) {
    return <></>;
  }

  return (
    <HookFormResolver onSubmit={() => {}}>
      {() => {
        return (
          <Fragment>
            <TaxReturnForm
              readOnly={true}
              submit={() => {}}
              defaultValue={taxreturn?.cells}
              version={taxreturn!.formVersionId ?? ''}
            />
            <BtnToolbar>
              <BtnGroup>
                <Button action={ButtonAction.cancel} variant="secondary" onClick={onCancel} />
              </BtnGroup>
              <BtnGroup>
                <Button
                  action={ButtonAction.delete}
                  variant="danger"
                  text={buttons(t, 'reject')}
                  onClick={() => navigate(`/statements/reject-taxreturn/${id}`)}
                />

                <Button
                  action={ButtonAction.save}
                  text={buttons(t, 'approve')}
                  variant="primary"
                  onClick={() => navigate(`/statements/approve-taxreturn/${id}`)}
                />
              </BtnGroup>
            </BtnToolbar>
          </Fragment>
        );
      }}
    </HookFormResolver>
  );
});
